import React from 'react';
import styled from 'styled-components';
import { TableCellProps } from 'component-library-and-tools';

import RadioButton from 'shared/components/RadioButton';

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DestinationSelectionCell = ({
  value: destinationType,
  selectedDestination,
}: TableCellProps) => (
  <StyledContainer>
    <RadioButton
      name='destination'
      isSelected={destinationType === selectedDestination.type}
    />
  </StyledContainer>
);

export default DestinationSelectionCell;
